import { useState } from "react";
import { useNavigate } from "react-router-dom";
import '../styles/dropdown.css';

const Dropdown = ({ title, items, workbookName }) => {
  const [isOpen, setIsOpen] = useState(false);
  const navigate = useNavigate();

  const toggleDropdown = () => setIsOpen(!isOpen);
  const isStatic = items.length === 0;

  return (
    <div className="dropdown__menu">
      <button
        onClick={() => {
          if (isStatic) navigate('/home');
          else toggleDropdown();
        }}
      >

        {title} {items.length > 0 && (isOpen ? "▲" : "▼")}

      </button>

      {isOpen && (
        <div className="dropdown__item">
          {items.map((item, index) => {

            const label = typeof item === 'string' ? item : item.label;

            const handle = () => {
              setIsOpen(false);

              if (typeof item === 'string') {

                // sheet navigation
                const wrkBook = encodeURIComponent(workbookName);
                const shtName = encodeURIComponent(item);
                navigate(`/view/${wrkBook}/${shtName}`);

              } else if (item.path) {

                // direct route navigation
                navigate(item.path);

              } else if (typeof item.action === 'function') {

                // custom callback
                item.action();
              }
            };

            return (
              <button key={index} onClick={handle}>
                {label}
              </button>
            );
            
          })}
        </div>
      )}
    </div>
  );
};

export default Dropdown;
